const API_URL = 'https://portal.clevory.info/events/clevoryacademy';
const API_URL_GET_IMAGE = 'https://portal.clevory.info/event/get_image';

const DEFAULT_IMAGE = '/assets/images/blogs/blog1.jpg';

const formatDate = (dateString) => {
	if (!dateString) return '';

	const date = new Date(dateString.replace(' ', 'T'));

	if (Number.isNaN(date.getTime())) return '';

	return new Intl.DateTimeFormat('en-US', {
		month: 'short',
		day: '2-digit',
		year: 'numeric',
	}).format(date);
};

const getImageUrl = (id) => {
	if (!id) return DEFAULT_IMAGE;

	return `${API_URL_GET_IMAGE}/${id}`;
};

const mapTrainingItem = (item, index) => ({
	id: item.id ?? index + 1,
	date: formatDate(item.startdate),
	category:
		Array.isArray(item.tag_ids) && item.tag_ids.length > 0
			? item.tag_ids[0]
			: 'Training',
	title: item.name || 'Untitled Training',

	// Image from API using event id
	image: getImageUrl(item.id),

	// fallback image if API image fails
	defaultImage: DEFAULT_IMAGE,

	courseid: item.courseid,
	description: item.description || '',
	address: item.address || '',
	startdate: item.startdate || '',
	enddate: item.enddate || '',
});

export const getFormationALaCarteTrainings = async () => {
	try {
		const response = await fetch(API_URL, {
			credentials: 'include',
		});

		console.log('API Response:', response);
		console.log('API Response Status:', API_URL, response.status);

		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(
				`HTTP error! status: ${response.status} - ${
					errorText || 'No response body'
				}`,
			);
		}

		const data = await response.json();

		if (!Array.isArray(data)) {
			console.error('API did not return an array:', data);
			return [];
		}

		console.log('Fetched Trainings Data:', data);

		return data.map(mapTrainingItem);
	} catch (error) {
		console.error('Error fetching Clevory Academy trainings:', error);
		return [];
	}
};
